export const screen = {
  xs: "375px",
  s: "520px",
  m: "835px",
  l: "1340px",
  xl:"1440px",
  xxl:"1600px"
}
